module.exports = __webpack_public_path__ + "public/img/ico-tabbar-inactive-clients.c8261acc.svg";